export default {
  name: 'oz-card-skeleton',
}
